module.exports = __webpack_public_path__ + "static/img/2.9483ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lamikal/2.jpg
// module id = +qyv
// module chunks = 0